import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Crown, Check } from 'lucide-react';
import { loadStripe } from '@stripe/stripe-js';
import { toast } from 'sonner';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_placeholder');

const FEATURES = [
  'Full 30/60/90 day runway projection',
  'AI Budget Feasibility Analysis',
  'Budget-to-Reality Finder (food & lodging)',
  'Smart Daily Budget Engine',
  'Advanced spending insights',
  'Cloud backup & sync',
  'Export to CSV/PDF',
];

const PaywallModal = ({ open, onClose }) => {
  const handleSubscribe = async (priceType) => {
    try {
      toast.info('Stripe integration in progress');
      // In production, this would create a Stripe checkout session
      // const response = await axios.post(`${API}/subscription/create-checkout-session`, {
      //   price_id: priceType === 'monthly' ? process.env.REACT_APP_STRIPE_PRICE_ID_MONTHLY : process.env.REACT_APP_STRIPE_PRICE_ID_YEARLY,
      //   user_email: 'user@example.com'
      // });
      // const stripe = await stripePromise;
      // await stripe.redirectToCheckout({ sessionId: response.data.sessionId });
    } catch (error) {
      console.error('Subscription error:', error);
      toast.error('Failed to start subscription');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="paywall-modal" className="bg-card border-border max-w-md">
        <DialogHeader>
          <DialogTitle className="text-3xl font-heading flex items-center gap-2">
            <Crown className="w-8 h-8 text-primary" />
            Go Premium
          </DialogTitle>
          <p className="text-muted-foreground mt-2">
            Keep traveling longer with smart budget insights
          </p>
        </DialogHeader>

        {/* Features List */}
        <div className="space-y-3 py-4">
          {FEATURES.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
              <span className="text-foreground">{feature}</span>
            </div>
          ))}
        </div>

        {/* Pricing */}
        <div className="space-y-3">
          <Button
            data-testid="subscribe-monthly-button"
            onClick={() => handleSubscribe('monthly')}
            className="w-full h-14 rounded-full bg-primary text-primary-foreground font-semibold shadow-primary hover:shadow-primary-hover transition-all duration-300"
          >
            $4.99/month
          </Button>

          <Button
            data-testid="subscribe-yearly-button"
            onClick={() => handleSubscribe('yearly')}
            variant="outline"
            className="w-full h-14 rounded-full border-primary text-primary hover:bg-primary/10"
          >
            $30/year
            <span className="ml-2 text-sm text-muted-foreground">(Save 39%)</span>
          </Button>

          <Button
            data-testid="close-paywall-button"
            onClick={onClose}
            variant="ghost"
            className="w-full text-muted-foreground"
          >
            Maybe later
          </Button>
        </div>

        <p className="text-xs text-center text-muted-foreground pt-2">
          Cancel anytime. No commitments.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default PaywallModal;